<!--  -->
<template>
    <div class="history">
        <van-tabs sticky v-model="active" color="#009AF3" @change="tabChange" animated title-active-color="#009AF3" title-inactive-color="#333333" line-width="50%">
            <van-tab title="订单申诉" name="1">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                    <van-list class="history-vant-list" :finished-text="dataList.length == 0 ? '' : '暂无更多了'" v-model="loading" :immediate-check="false" :finished="finished" :offset="100" @load="onLoad">
                        <template #default>
                            <div class="history-list">
                                <div class="flex align-center" @click="skipDetail((type = 1), item.id)" v-for="(item, index) in dataList" :key="index">
                                    <div class="history-list-item">
                                        <div class="parkingPay-carInfo-content">
                                            <div class="carInfo-content-item flex align-center">
                                                <img class="carInfo-content-item1" src="@/assets/images/pay/parking-time.png" alt="" />
                                                <p class="carInfo-content-item-title">订单类型</p>
                                                <p class="carInfo-content-item-value">
                                                    <span v-if="item.orderType == 1">余额充值</span>
                                                    <span v-else-if="item.orderType == 2">路内停车缴费</span>
                                                    <span v-else-if="item.orderType == 3">预约缴费</span>
                                                    <span v-else-if="item.orderType == 4">预约超时缴费</span>
                                                    <span v-else-if="item.orderType == 5">停车预缴</span>
                                                    <span v-else-if="item.orderType == 6">路外停车缴费</span>
                                                    <span v-else-if="item.orderType == 7">会员升级费用</span>
                                                    <span v-else-if="item.orderType == 8">月卡购买</span>
                                                </p>
                                            </div>
                                            <div v-if="item.payTime" class="carInfo-content-item flex align-center">
                                                <img class="carInfo-content-item1" src="@/assets/images/pay/parking-time.png" alt="" />
                                                <p class="carInfo-content-item-title">支付时间</p>
                                                <p class="carInfo-content-item-value">{{ item.payTime.split("T").join(" ") }}</p>
                                            </div>
                                            <div v-if="item.orderId" class="carInfo-content-item flex align-center">
                                                <img class="carInfo-content-item1" src="@/assets/images/pay/parking-time.png" alt="" />
                                                <p class="carInfo-content-item-title">订单号</p>
                                                <p class="carInfo-content-item-value">{{ item.orderId }}</p>
                                            </div>

                                            <div v-if="item.stallCode" class="carInfo-content-item flex align-center">
                                                <img class="carInfo-content-item1" src="@/assets/images/pay/parkingPay-number.png" alt="" />
                                                <p class="carInfo-content-item-title">泊位号</p>
                                                <p class="carInfo-content-item-value">{{ item.stallCode }}</p>
                                            </div>
                                            <div v-if="item.plateNum" class="carInfo-content-item flex align-center">
                                                <img class="carInfo-content-item1" src="@/assets/images/pay/parkingPay-code.png" alt="" />
                                                <p class="carInfo-content-item-title">车牌号</p>
                                                <p class="carInfo-content-item-value">{{ item.plateNum }}</p>
                                            </div>
                                        </div>
                                        <div class="history-item-header flex align-center justify-between">
                                            <p class="history-item-site"></p>
                                            <p class="history-item-payMoney">￥{{ item.payMoney }}</p>
                                        </div>
                                        <div class="history-item-bottom">
                                            <div class="text">
                                                <div class="title">投诉订单</div>
                                                <div class="reson">诉求原因： {{ item.appealContent }}</div>
                                                <div class="time">投诉时间：{{ item.appealTime.split("T").join(" ") }}</div>
                                            </div>
                                            <div class="img">
                                                <img v-if="item.status == 1" src="@/assets/images/suggestion/loading-s.png" alt="" />
                                                <img v-if="item.status == 2" src="@/assets/images/suggestion/success.png" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </van-list>
                </van-pull-refresh>
                <van-empty description="暂无数据" v-if="dataList.length == 0 && finished" />
            </van-tab>
            <van-tab title="投诉建议" name="2">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                    <van-list class="history-vant-list" :finished-text="dataList.length == 0 ? '' : '暂无更多了'" v-model="loading" :immediate-check="false" :finished="finished" :offset="100" @load="onLoad">
                        <template #default>
                            <div class="history-list">
                                <div class="flex align-center" v-for="(item, index) in dataList" :key="index">
                                    <div class="history-list-item">
                                        <div class="type-two-content">
                                            <div>
                                                <span v-if="item.type == 1">车牌认证</span>
                                                <span v-if="item.type == 2">关于停车</span>
                                                <span v-if="item.type == 3">关于充值</span>
                                                <span v-if="item.type == 4">关于缴费</span>
                                                <span v-if="item.type == 5">其他</span>
                                            </div>
                                            <div class="right" @click="skipDetail((type = 2), item.id)">查看详情></div>
                                        </div>
                                        <div class="line"></div>
                                        <div class="history-item-type">
                                            <div class="text">
                                                <div class="reson">问题建议： {{ item.complaintContent }}</div>
                                                <div class="time">提交时间：{{ item.complaintTime.split("T").join(" ") }}</div>
                                            </div>
                                            <div class="img">
                                                <img v-if="item.status == 1" src="@/assets/images/suggestion/replying.png" alt="" />
                                                <img v-if="item.status == 2" src="@/assets/images/suggestion/replied.png" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </van-list>
                </van-pull-refresh>
                <van-empty description="暂无数据" v-if="dataList.length == 0 && finished" />
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import { queryOrderAppealList, queryComplaintAdviseList } from "@/api/api";

import { secondToMinute } from "@/libs/tools";

export default {
    name: "complainHtistory",
    components: {},
    data() {
        return {
            active: "1",
            refreshing: false, // refresh 是否处于加载状态
            loading: false, //List 是否处于加载状态
            finished: false, // List 是否已加载完成
            dataList: [],
            images: [],
            showPreviewImg: false,
            query: {
                pageNum: 0,
                pageSize: 10,
            },
        };
    },

    mounted() {
        this.onLoad();
    },

    methods: {
        secondToMinute,
        //跳转到详情页
        skipDetail(type, id) {
            this.$router.push({
                path: "/suggestion/orderAppeal/orderAppealDetail",
                query: { type: type, id: id },
            });
        },

        //标签切换
        tabChange(e) {
            this.dataList = []; //清空数据
            this.finished = false;
            this.refreshing = true;
            this.loading = true;
            //初始化分页数据
            this.query = {
                pageNum: 0,
                pageSize: 10,
            };
            this.onLoad();
        },

        //下拉刷新时触发
        onRefresh() {
            console.log("onRefresh");
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
        onLoad() {
            console.log("onLoad");
            console.log(this.loading);
            this.query.pageNum += 1;
            if (this.refreshing) {
                this.dataList = [];
                this.refreshing = false;
                this.query.pageNum = 1;
            }
            //订单申诉

            if (this.active == "1") {
                queryOrderAppealList(this.query).then((res) => {
                    if (res.code == 200) {
                        if (res.data.rows != null) this.dataList = [...this.dataList, ...res.data.rows];
                        //最后一页 length小于10
                        if (res.data.rows == null || (res.data.rows && res.data.rows.length < 10)) {
                            this.finished = true;
                        }
                    }
                    this.loading = false;
                });
            }
            //投诉建议
            else if (this.active == "2") {
                queryComplaintAdviseList(this.query).then((res) => {
                    if (res.code == 200) {
                        if (res.data.rows != null) this.dataList = [...this.dataList, ...res.data.rows];
                        //最后一页 length小于10
                        if (res.data.rows == null || (res.data.rows && res.data.rows.length < 10)) {
                            this.finished = true;
                        }
                    }
                    this.loading = false;
                });
            }
        },
    },
};
</script>
<style lang="less" scoped>
.van-tabs__wrap {
    position: fixed;
    top: 0;
}
.history {
    font-family: PingFang SC;
    .history-list {
        .history-radio {
            margin-right: 20px;
        }
        padding: 16px 24px;
        .history-list-item {
            width: 702px;
            min-height: 100px;
            border-radius: 16px;
            background-color: #fff;
            margin-bottom: 16px;

            .history-item-header {
                width: 100%;
                height: 73px;
                padding: 0 30px;
                margin-top: 10px;
                border-top: 1px solid #dbdada;
                .history-item-site {
                    font-size: 30px;
                    color: #333333;
                }
                .history-item-payMoney {
                    color: #009af3;
                    font-size: 36px;
                }
                .history-item-status {
                    font-size: 30px;
                }
                .color-gray {
                    color: #999;
                }
                .color-red {
                    color: #f96161;
                }
            }

            .history-item-bottom {
                width: 638px;
                height: 184px;
                // padding: 20px 30px 20px 30px;
                color: #999;
                margin: 0 auto 20px auto;
                background-color: #f5f5f5;
                overflow: hidden;
                .text {
                    display: inline-block;
                    width: 528px;
                    padding: 20px 30px 20px 30px;
                }
                .img {
                    display: inline-block;
                    position: relative;
                    top: 32px;
                    height: 100px;
                    width: 110px;
                }

                img {
                    height: 100%;
                    width: 100%;
                }
                .title {
                    color: #333333;
                    font-size: 30px;
                    padding: 5px 0;
                }
                .reson {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    color: #666666;
                    font-size: 28px;
                    padding: 5px 0;
                }
                .time {
                    color: #666666;
                    padding: 5px 0;

                    font-size: 28px;
                }
            }

            .type-two-content {
                display: flex;
                justify-content: space-between;
                font-size: 30px;
                padding: 24px 30px 20px;
                .right {
                    color: #009af3;
                }
            }
            .line {
                width: 90%;
                margin: 0 auto;
                border-bottom: 0.025px #dbdada solid;
            }

            .history-item-type {
                // display: flex;
                // justify-content: space-between;
                // width: 100%;
                color: #999;
                margin: 0 auto;
                overflow: hidden;
                .text {
                    display: inline-block;
                    width: 590px;
                    padding: 20px 30px 20px 30px;
                }
                .img {
                    display: inline-block;
                    position: relative;
                    top: 40px;
                    height: 100px;
                    width: 110px;
                }

                img {
                    height: 100%;
                    width: 100%;
                }
                .title {
                    color: #333333;
                    font-size: 30px;
                    padding: 5px 0;
                }
                .reson {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    color: #666666;
                    font-size: 28px;
                    padding: 5px 0;
                }
                .time {
                    color: #666666;
                    padding: 5px 0;

                    font-size: 28px;
                }
            }
            .parkingPay-carInfo-content {
                // flex: 1;
                padding: 24px 20px 27px;

                .carInfo-content-header {
                    font-size: 32px;
                    font-weight: 500;
                    color: #212121;
                    margin-bottom: 30px;
                }

                .carInfo-content-item {
                    margin-bottom: 16px;

                    .carInfo-content-item1 {
                        width: 24px;
                        height: 24px;
                    }

                    .carInfo-content-item2 {
                        width: 24px;
                        height: 28px;
                    }

                    .carInfo-content-item-title {
                        margin-left: 17px;
                        vertical-align: top;
                    }

                    .carInfo-content-item-value {
                        margin-left: auto;
                        color: #666666;
                    }
                }
            }
            .history-item-pay {
                padding: 0 30px 30px;
                text-align: right;
                .history-item-pay-btn {
                    width: 160px;
                    height: 48px;
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>
